export default {
      id: "huge-config-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-config",
      toString: function () {
        return this.url;
      }
    }